import { useEffect, useRef, useState } from "react";

interface ShareButtonProps {
  title: string;
  summary: string;
  tone?: "default" | "onDark";
}

export default function ShareButton({ title, summary, tone = "default" }: ShareButtonProps) {
  const [tip, setTip] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
    };
  }, []);

  const showTip = (message: string) => {
    setTip(message);
    if (timerRef.current) window.clearTimeout(timerRef.current);
    timerRef.current = window.setTimeout(() => setTip(""), 2600);
  };

  const handleShare = async () => {
    const url = window.location.href;
    if (typeof navigator.share === "function") {
      try {
        await navigator.share({ title, text: summary, url });
        return;
      } catch {
        return;
      }
    }
    try {
      await navigator.clipboard.writeText(url);
      showTip("链接已复制到剪贴板");
    } catch {
      showTip("当前浏览器不支持自动复制，请手动复制地址栏链接");
    }
  };

  const styles =
    tone === "onDark"
      ? "border-background-50/35 text-background-50 hover:bg-background-50/10"
      : "border-background-300 text-foreground-800 hover:border-primary-400 hover:text-primary-600 bg-background-50";

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleShare}
        className={`inline-flex items-center gap-2 h-10 px-4 rounded-md border text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${styles}`}
      >
        <i className="ri-share-forward-line text-base leading-none" />
        分享
      </button>
      {tip && (
        <span className="absolute left-0 top-full mt-2 z-20 px-2.5 py-1.5 rounded-md bg-foreground-900 text-background-50 text-[11px] whitespace-nowrap">
          {tip}
        </span>
      )}
    </div>
  );
}